// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"3683":"StickyOptionsDrawer","5724":"ShippingDisclaimerDialog"}[chunkId] || chunkId) + ".chunk.min.css";
};